import { create } from "zustand";
import { setNumberLocale } from "@tasduvar/engine";
import { en } from "./en";

export type Lang = "tr" | "en";
const KEY = "tasduvar:lang";

function initial(): Lang {
  try { const v = window.localStorage.getItem(KEY); if (v === "en" || v === "tr") return v; } catch { /* yok */ }
  return "tr";
}

interface LangState { lang: Lang; setLang(l: Lang): void }
export const useLang = create<LangState>((set) => ({
  lang: typeof window === "undefined" ? "tr" : initial(),
  setLang(lang) { try { window.localStorage.setItem(KEY, lang); } catch { /* yok */ } setNumberLocale(lang === "en" ? "en-US" : "tr-TR"); set({ lang }); },
}));
if (typeof window !== "undefined") setNumberLocale(useLang.getState().lang === "en" ? "en-US" : "tr-TR");

/**
 * Çeviri: kaynak metin Türkçe anahtardır (gettext tarzı); İngilizce sözlükte yoksa Türkçe döner.
 * Bileşenler dil değişince App kökündeki `key={lang}` ile yeniden kurulur.
 */
export function t(s: string, lang: Lang = useLang.getState().lang): string {
  if (lang === "tr") return s;
  return en[s] ?? s;
}

/** Belirli bir dil için çevirmen (rapor dili proje ayarından gelir). */
export const translator = (lang: Lang) => (s: string): string => t(s, lang);

export const LANG_LABEL: Record<Lang, string> = { tr: "Türkçe", en: "English" };
